import MainLayout from "../../../../components/mainLayout";
import { PAGES } from "../../../../routes";
import audio from "../../../../assets/audio/26.mp3"
export default function P1() {
    return (
        <MainLayout
            title="Zsiadasz z wozu i skradasz się ukradkiem za starym Tornauem"
            question="O co chcesz zapytać starego Tornaua?"
            audio={audio}
            answers={{
                ans1: "Po co ci łódka?",
                ans2: "Czemu nazywają cię Samotnym Olędrem?",
                ans3: "Dlaczego chodzisz sam wieczorem nad rzeką?"
            }}
            links={{
                link1: PAGES.p42,
                link2: PAGES.p43,
                link3: PAGES.p44
            }}
            content={
                <div>
                    <p>
                        Buty po kilku krokach na podmokłej trawie robią się wilgotne i zaczynają rytmicznie chlupać. Stary Tornau nieruchomieje na chwilę, po czym rusza dalej wzdłuż rzeczki. Zauważasz, że ciągnie za sobą łódkę. Przemykasz ostrożnie przez brzozowy lasek. Nagle starzec odwraca się, kilkoma szybkimi susami doskakuje do ciebie i patrzy ci prosto w oczy.
                    </p>
                    <ul>
                        <li>Zgubiłem coś? – uśmiecha się dziwnie. – Czemu za mną idziesz?</li>
                    </ul>
                    <p>
                        Zapada niezręczna cisza.
                    </p>
                    <ul>
                        <li>Chcę tylko porozmawiać – zagajasz.</li>
                    </ul>


                </div>
            }
        />

    );
}